import React from 'react';
import { css } from '@emotion/css';

import { colors } from 'styles/colors';

import CalendarIcon from 'assets/icons/calendar.svg';
import ClockIcon from 'assets/icons/clock.svg';
import LocationIcon from 'assets/icons/location.svg';

type BookingConfirmedProps = {
    title: string;
    date: Date;
    location: string;
    duration: string;
};

const dateFormatter = new Intl.DateTimeFormat('da-DK', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
});
const timeFormatter = new Intl.DateTimeFormat('da-DK', { hour12: false, hour: 'numeric', minute: '2-digit' });

const BookingConfirmed = ({ title, date, location, duration }: BookingConfirmedProps) => {
    return (
        <div className={styles.content}>
            <span className={styles.titleText}>{title}</span>
            <div className={styles.infoRow}>
                <img src={CalendarIcon} alt="" />
                <span className={styles.infoText}>{dateFormatter.format(date)}</span>
            </div>
            <div className={styles.infoRow}>
                <img src={ClockIcon} alt="" />
                <span className={styles.infoText}>
                    {timeFormatter.format(date)} ({duration})
                </span>
            </div>
            <div className={styles.infoRow}>
                <img src={LocationIcon} alt="" />
                <span className={styles.infoText}>{location}</span>
            </div>
        </div>
    );
};

const styles = {
    content: css({
        width: '20rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.3rem',
        marginBottom: '3.5rem',
    }),
    titleText: css({
        width: '100%',
        marginBottom: '1rem',
        color: '#333',
        fontFamily: 'Segoe UI',
        fontSize: '1.25rem',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '1.3125rem',
    }),
    infoRow: css({
        width: '15.5rem',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        color: colors.primaryText,
        fontFamily: 'Segoe UI',
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
    }),
    infoText: css({
        fontSize: '14px',
        lineHeight: '19px',
        color: colors.primaryText,
        marginLeft: '7px',
    }),
};

export default BookingConfirmed;
